<template>
  <div>
    <v-form class="pa-3">
      <h4 class="text-xs-center mb-2">
        Promoción valida hasta
        <span
          class="primary--text"
          style="cursor:pointer;"
          @click="dateModal = true"
          >{{ $moment(expires_at).format('ddd DD MMM YYYY HH:mm') }}</span
        >
      </h4>
      <v-text-field label="Título" v-model="title"></v-text-field>
      <v-textarea label="Descripción" :rows="3" v-model="description">
      </v-textarea>
    </v-form>
    <v-divider class="mt-3"></v-divider>
    <slot></slot>
    <v-dialog v-model="dateModal" max-width="280px">
      <v-card>
        <v-date-picker
          class="elevation-0"
          color="primary"
          v-model="expires_at"
          locale="es-es"
          first-day-of-week="1"
          full-width
        ></v-date-picker>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dateModal: false,
      id: null,
      title: '',
      description: '',
      expires_at: ''
    }
  },
  watch: {
    expires_at: function(val) {
      if (val) this.dateModal = false
    }
  }
}
</script>